import { render } from "./dj.vue?vue&type=template&id=6f83d173&scoped=true"
import script from "./dj.vue?vue&type=script&lang=js"
export * from "./dj.vue?vue&type=script&lang=js"

import "./dj.vue?vue&type=style&index=0&id=6f83d173&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f83d173"]])

export default __exports__